export const oferta = `# Публичная оферта на оказание услуг

**Сайт:** kolodec-septiki.ru  
**Дата публикации:** 7 мая 2026 г.

---

## 1. Общие положения

1.1. Настоящий документ является публичной офертой в соответствии со ст. 435 и ч. 2 ст. 437 Гражданского кодекса Российской Федерации.

1.2. **Исполнитель:**

- **Наименование:** ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ
- **ИНН:** 752405626175
- **ОГРНИП:** 325508100039277
- **Адрес:** 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1
- **Сайт:** https://kolodec-septiki.ru
- **Email:** info@kolodec-septiki.ru

1.3. **Предмет оферты:** Исполнитель оказывает услуги в сфере **строительство колодцев и монтаж септиков**, включая: копка колодцев, монтаж септиков, автономная канализация, водоснабжение.

1.4. **Акцепт оферты.** Акцептом настоящей оферты является любое из следующих действий Заказчика:
- оформление заявки на сайте kolodec-septiki.ru;
- подтверждение заявки по телефону или электронной почте;
- внесение предоплаты (если применимо);
- подписание договора/заказа-наряда.

С момента акцепта Договор считается заключённым без подписания отдельного документа.

---

## 2. Термины и определения

- **Исполнитель** — ИП Серебренников Р.А., оказывающий услуги.
- **Заказчик** — физическое или юридическое лицо, акцептовавшее настоящую оферту.
- **Услуги** — работы по строительство колодцев и монтаж септиков, перечень которых согласовывается при оформлении заказа.
- **Заявка** — обращение Заказчика (через сайт, по телефону или email) с просьбой оказать услуги.
- **Заказ** — согласованный перечень услуг с указанием стоимости и сроков.

---

## 3. Порядок оказания услуг

3.1. Заказчик оформляет Заявку одним из доступных способов: через форму на сайте, по телефону или электронной почте.

3.2. Исполнитель в течение **1 рабочего дня** связывается с Заказчиком для уточнения параметров Заявки.

3.3. По результатам согласования формируется **Заказ** с указанием:
- перечня и объёма услуг;
- стоимости;
- сроков выполнения;
- адреса объекта (при необходимости).

3.4. Выезд специалиста для оценки объёма работ и составления сметы осуществляется **бесплатно**, если иное не предусмотрено условиями конкретной услуги.

3.5. Исполнитель вправе привлекать субподрядчиков, сохраняя ответственность перед Заказчиком.

---

## 4. Стоимость и порядок оплаты

4.1. Стоимость услуг определяется индивидуально для каждого Заказа на основании:
- прайс-листа, размещённого на сайте kolodec-septiki.ru;
- индивидуального расчёта по параметрам объекта.

4.2. Оплата производится в следующем порядке (если иное не согласовано):
- предоплата — **50%** от стоимости Заказа при подтверждении;
- окончательный расчёт — **50%** по факту выполнения работ.

4.3. Способы оплаты:
- безналичный перевод на расчётный счёт Исполнителя;
- наличными при приёмке работ;
- иные способы по согласованию сторон.

4.4. Реквизиты для оплаты:

| Реквизит | Значение |
|---|---|
| Получатель | ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ |
| ИНН | 752405626175 |
| Расчётный счёт | 40802810500007775572 |
| Банк | АО «ТБанк» |
| БИК | 044525974 |
| Кор. счёт | 30101810145250000974 |

---

## 5. Права и обязанности сторон

### 5.1. Исполнитель обязуется:
- Выполнить работы качественно и в согласованные сроки;
- Использовать материалы надлежащего качества (если входят в стоимость);
- Уведомить Заказчика о возможных задержках не позднее чем за 24 часа;
- Предоставить гарантию на выполненные работы в соответствии с разделом 7.

### 5.2. Заказчик обязуется:
- Предоставить достоверные данные при оформлении Заявки;
- Обеспечить доступ к объекту в согласованные сроки;
- Принять выполненные работы и произвести оплату;
- Уведомить Исполнителя о претензиях в течение 5 рабочих дней после приёмки.

---

## 6. Сроки выполнения

6.1. Сроки определяются индивидуально при согласовании Заказа.

6.2. Срок может быть изменён по согласованию сторон, если:
- изменился объём работ;
- возникли обстоятельства, не зависящие от сторон (форс-мажор, погодные условия и т.п.).

---

## 7. Гарантии

7.1. Исполнитель предоставляет гарантию на выполненные работы:
- строительно-монтажные работы — **12 месяцев** с даты приёмки;
- на использованные материалы — в соответствии с гарантией производителя;
- иные сроки — по отдельному согласованию.

7.2. Гарантийные обязательства не распространяются на дефекты, возникшие вследствие:
- нарушения Заказчиком правил эксплуатации;
- механических повреждений по вине третьих лиц;
- форс-мажорных обстоятельств.

---

## 8. Возврат денежных средств

8.1. В случае отказа Заказчика от услуг **до начала работ** — предоплата возвращается в полном объёме в течение 5 рабочих дней.

8.2. В случае отказа **после начала работ** — возврату подлежит предоплата за вычетом стоимости фактически выполненных работ и понесённых расходов.

8.3. Возврат осуществляется на банковские реквизиты, указанные Заказчиком, в течение **10 рабочих дней** с момента согласования суммы.

---

## 9. Ответственность сторон

9.1. Стороны несут ответственность в соответствии с законодательством РФ.

9.2. Исполнитель не несёт ответственности за:
- невозможность исполнения по вине Заказчика;
- ущерб, возникший вследствие предоставления Заказчиком недостоверных данных;
- форс-мажорные обстоятельства.

9.3. Совокупная ответственность Исполнителя не может превышать стоимости оплаченных услуг по соответствующему Заказу.

---

## 10. Конфиденциальность

10.1. Персональные данные Заказчика обрабатываются в соответствии с **Политикой обработки персональных данных**, размещённой на сайте: https://kolodec-septiki.ru/privacy-policy

10.2. Данные используются исключительно для выполнения обязательств по настоящей оферте.

---

## 11. Разрешение споров

11.1. Споры решаются путём переговоров. Срок ответа на претензию — **10 рабочих дней**.

11.2. При недостижении соглашения споры рассматриваются в судебном порядке:
- для потребителей — в суде по месту жительства Заказчика (в соответствии с Законом РФ «О защите прав потребителей»);
- для юридических лиц — в Арбитражном суде Московской области.

---

## 12. Срок действия оферты

12.1. Оферта действует с момента публикации на сайте kolodec-septiki.ru и до её отзыва Исполнителем.

12.2. Исполнитель вправе изменить условия оферты, опубликовав новую редакцию. Изменения применяются к заявкам, поданным после публикации.

---

## 13. Реквизиты Исполнителя

**ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ**  
ИНН: 752405626175 | ОГРНИП: 325508100039277  
Адрес: 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1  
Расчётный счёт: 40802810500007775572  
Банк: АО «ТБанк»  
БИК: 044525974 | Кор. счёт: 30101810145250000974  
Адрес банка: 127287, г. Москва, ул. Хуторская 2-я, д. 38А, стр. 26  
Email: info@kolodec-septiki.ru
`;
